import {
  deleteWorkRecords,
  downloadCheckResultCsv,
  downloadMediaFiles,
} from './api/apis';
import { OPEN_USER_PROMPT } from './actionTypes';

/** 最近削除した項目機能Action一覧 */
export const ActionTypes = {
  SUCCESS_API_DOWNLOAD_MEDIA_FILES:
    'operatorWorks/SUCCESS_API_DOWNLOAD_MEDIA_FILES',
  SUCCESS_API_DOWNLOAD_CHECK_RESULT:
    'operatorWorks/SUCCESS_API_DOWNLOAD_CHECK_RESULT',
  SUCCESS_API_DELETE_WORK_RECORDS:
    'operatorWorks/SUCCESS_API_DELETE_WORK_RECORDS',
};

/**
 * 指定した記録データのダウンロード
 *
 * @param {func} dispatch dispatch関数
 * @param {string} apiToken APIトークン
 * @param {object} ids 記録データIDオブジェクト
 */
export const download = (dispatch, apiToken, ids, groupId) => {
  dispatch(
    downloadMediaFiles(
      apiToken,
      ids,
      groupId,
      new Array(ActionTypes.SUCCESS_API_DOWNLOAD_MEDIA_FILES),
    ),
  );
};

/**
 * 指定した記録データの信憑性チェック結果(CSV形式)をダウンロード
 *
 * @param {func} dispatch dispatch関数
 * @param {string} apiToken APIトークン
 * @param {object} ids 記録データID
 */
export const downloadCheckResult = (dispatch, apiToken, ids) => {
  dispatch(
    downloadCheckResultCsv(
      apiToken,
      ids,
      new Array(ActionTypes.SUCCESS_API_DOWNLOAD_CHECK_RESULT),
    ),
  );
};

/**
 * 記録データ無効化
 *
 * @param {func} dispatch dispatch関数
 * @param {string} apiToken APIトークン
 * @param {func} formatMessage メッセージ生成関数
 * @param {object} params requestパラメータ
 */
export const disableWorkRecords = (
  dispatch,
  apiToken,
  formatMessage,
  params,
) => {
  const promptMessage = formatMessage({ id: 'userPrompt.message.dataDelete' });
  const buttonOk = formatMessage({ id: 'userPrompt.button.delete' });
  const buttonNo = formatMessage({ id: 'userPrompt.button.noDelete' });
  const buttonArray = [
    { name: buttonOk, type: 0 },
    { name: buttonNo, type: 1 },
  ];
  const onAccept = ret => {
    if (ret === 0) {
      dispatch(
        deleteWorkRecords(
          apiToken,
          params,
          new Array(ActionTypes.SUCCESS_API_DELETE_WORK_RECORDS),
        ),
      );
    }
  };
  dispatch({ type: OPEN_USER_PROMPT, promptMessage, buttonArray, onAccept });
};
